import { AnalysisResult } from "../types";
import { supabase } from "./supabaseClient";

export const analyzeTranscript = async (transcript: string): Promise<AnalysisResult> => {
  if (!transcript) {
    throw new Error("A transcrição está vazia.");
  }

  try {
    const { data, error } = await supabase.functions.invoke('analyze-transcript', {
      body: { transcription: transcript },
    });

    if (error) {
      console.error("Supabase Function Error:", error);
      // O Supersabe pode retornar erro como objeto JSON com mensagem
      throw new Error(error.message || "Erro ao conectar com a Edge Function.");
    }

    if (!data) {
      throw new Error("Nenhuma resposta recebida da função.");
    }

    // A função já retorna o JSON limpo, mas podemos fazer um parse extra se for string
    const result = typeof data === 'string' ? JSON.parse(data) : data;

    return result as AnalysisResult;

  } catch (error: any) {
    console.error("Analysis Service Error:", error);
    throw error;
  }
};